export default {
  install: (app) => {
    app.config.globalProperties.$wait = ms => new Promise(resolve => setTimeout(resolve, ms))
  },
}
